import React, { useState } from 'react';
import PropTypes from 'prop-types';
import WizardInput from 'components/wizard/WizardInput';
import { Col, Row } from 'react-bootstrap';
import { Form } from 'react-bootstrap';

const Civilite = ['Monsieur', 'Madame'];

const InfosFournisseur = ({ register, errors, watch, setValue }) => {
  const [civilite, setCivilite] = useState(watch('civilite') || Civilite[0]);

  return (
    <>
      <h5 className="mb-2">Détails de l'entreprise</h5>
      <WizardInput
        label="Nom de l'entreprise*"
        name="societe"
        errors={errors}
        formGroupProps={{ className: 'mb-3' }}
        formControlProps={{
          ...register('societe', {
            required: 'Nom entreprise est obligatoire',
            minLength: {
              value: 2,
              message: "Nom de l'entreprise est obligatoire"
            }
          })
        }}
      />

      <Row className="g-2 mb-1">
        <WizardInput
          label="Numéro d'identification fiscale"
          name="idFisc"
          errors={errors || {}}
          formGroupProps={{ className: 'mb-3' }}
          formControlProps={{
            ...register('idFisc')
          }}
        />
      </Row>
      <Row className="g-2 mb-0">
        <WizardInput
          label="Site web"
          name="siteWeb"
          errors={errors || {}}
          formGroupProps={{ className: 'mb-3' }}
          formControlProps={{
            ...register('siteWeb')
          }}
        />
      </Row>
      <h5 className="mb-2">Personnes à contacter</h5>
      <Row className="g-2 mb-3">
        {Civilite.map((tvaValue, index) => (
          <Col key={index}>
            <>
              <Form.Check
                inline
                type="radio"
                id="item1Radio"
                label={`${tvaValue}`}
                name={`item1Radio`}
                onClick={() => {
                  setCivilite(Civilite[index]);
                  setValue('civilite', Civilite[index]);
                }}
                defaultChecked={civilite === Civilite[index]}
              />
            </>
          </Col>
        ))}
      </Row>
      <Row className="g-2 mb-1">
        <WizardInput
          label="Nom"
          name="nomResponsable"
          errors={errors || {}}
          formGroupProps={{ className: 'mb-3' }}
          formControlProps={{
            ...register('nomResponsable')
          }}
        />
      </Row>
      <Row className="g-2 mb-0">
        <WizardInput
          label="Email"
          name="email"
          errors={errors || {}}
          formGroupProps={{ className: 'mb-3' }}
          formControlProps={{
            ...register('email')
          }}
        />
      </Row>
    </>
  );
};

InfosFournisseur.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  watch: PropTypes.func,
  setValue: PropTypes.func
};

export default InfosFournisseur;
